import { Component, input, OnInit, signal } from "@angular/core";
import { DataTable, IDataClassConfig } from "app/classes/data-table/data-table";
import { Site } from "app/classes/site";
import { EquipmentSchedule, IEquipmentScheduleItem, ScheduleService } from "app/shared/schedule.service";

@Component({
  selector: "app-site-schedules",
  standalone: false,
  templateUrl: "./site-schedules.component.html",
  styleUrl: "./site-schedules.component.css",
})
export class SiteSchedulesComponent implements OnInit {

  site = input.required<Site>();
  schedules = signal<EquipmentSchedule[]>(null);
  schedule = signal<EquipmentSchedule>(null);

  dataTable = signal<DataTable>(null);
  dataTableConfig: IDataClassConfig = {
    "day": { "valueType": "string", "title": "Title", "align": "left" },
    "timeOn": { "valueType": "date", "title": "Start", "align": "left" },
    "timeOff": { "valueType": "date", "title": "End", "align": "left" },
  }

  constructor(private scheduleService: ScheduleService) { }

  ngOnInit() {
    if (this.site().id === 16) {
      this.get();
    } else {
      this.schedules.set([]);
    }
  }

  get() {
    const schedule = new EquipmentSchedule();
    schedule.title = "Building Occupancy";
    this.schedules.set([schedule]);
    this.schedule.set(schedule);
  }

  clickSchedule(schedule: EquipmentSchedule) {
    this.schedule.set(schedule);
  }

  clearDay(day: IEquipmentScheduleItem) {
    this.schedule.update(s => {
      day.timeOn = null;
      day.timeOff = null;

      return s;
    });
  }
}
